import {useMutation} from '@tanstack/react-query';
import {type} from 'arktype';
import {AccountId} from '~/entities/operations-fiat';
import {ErroneousServerResult, expectEither, HttpClient, POST, useHttpClient} from '~/library/network-facade';

const CreateWithdrawSepaParams = type({
    amount: 'string',
    iban: 'string',
});
type CreateWithdrawSepaParams = typeof CreateWithdrawSepaParams.infer;

const Order = type({
    id: 'number',
    type: 'string',
    status: 'string',
    title: 'string',
    created_at: 'string.date',
});

function createWithdrawSepaOrder(http: HttpClient, accountId: AccountId, params: CreateWithdrawSepaParams) {
    return http(`v1/accounts/${accountId}/send/banks/sepa`, POST(params)).then(
        ...expectEither({
            200: Order,
            400: ErroneousServerResult,
        })
    );
}

export function useWithdrawSepaOrderMutation(accountId: AccountId) {
    const http = useHttpClient();
    return useMutation({
        mutationKey: ['v1/accounts/{accountId}/send/banks/sepa', accountId],
        mutationFn: async (params: CreateWithdrawSepaParams) => {
            const response = await createWithdrawSepaOrder(http, accountId, params);
            const {status, json} = response;

            switch (status) {
                case 200:
                    return {value: json};
                case 400:
                    return {problem: json};
                case 'Abort':
                    throw response.reason;
            }
        },
    });
}
